module.exports = __webpack_public_path__ + "static/media/AshleyBrooke-4689-plaintexture-3263580115-O_s.2a786b53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/AshleyBrooke-4689-plaintexture-3263580115-O_s.jpg
// module id = 363
// module chunks = 0